// import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// class ApiService {
//   private axiosInstance: AxiosInstance;

//   constructor() {
//     this.axiosInstance = axios.create({
//       baseURL: API_URL,
//       timeout: 10000,
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     this.setupInterceptors();
//   }

//   private setupInterceptors(): void {
//     // Request interceptor - Add auth token
//     this.axiosInstance.interceptors.request.use(
//       (config: InternalAxiosRequestConfig) => {
//         const token = localStorage.getItem('accessToken');
//         if (token && config.headers) {
//           config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//       },
//       (error: AxiosError) => {
//         return Promise.reject(error);
//       }
//     );

//     // Response interceptor - Handle errors
//     this.axiosInstance.interceptors.response.use(
//       (response) => response,
//       async (error: AxiosError) => {
//         if (error.response?.status === 401) {
//           // Token expired - try to refresh
//           const refreshToken = localStorage.getItem('refreshToken');
//           if (refreshToken) {
//             try {
//               const response:any = await this.post('/api/auth/refresh-token', { refreshToken });
//               if (response.data.accessToken) {
//                 localStorage.setItem('accessToken', response.data.accessToken);
//                 localStorage.setItem('refreshToken', response.data.refreshToken);

//                 // Retry original request
//                 if (error.config) {
//                   error.config.headers = error.config.headers || {};
//                   error.config.headers.Authorization = `Bearer ${response.data.accessToken}`;
//                   return this.axiosInstance.request(error.config);
//                 }
//               }
//             } catch (refreshError) {
//               // Refresh failed - logout
//               localStorage.clear();
//               window.location.href = '/login';
//             }
//           } else {
//             // No refresh token - logout
//             localStorage.clear();
//             window.location.href = '/login';
//           }
//         }
//         return Promise.reject(error);
//       }
//     );
//   }

//   async get<T>(url: string, params?: any): Promise<T> {
//     const response = await this.axiosInstance.get<T>(url, { params });
//     return response.data;
//   }

//   async post<T>(url: string, data?: any): Promise<T> {
//     const response = await this.axiosInstance.post<T>(url, data);
//     return response.data;
//   }

//   async put<T>(url: string, data?: any): Promise<T> {
//     const response = await this.axiosInstance.put<T>(url, data);
//     return response.data;
//   }

//   async delete<T>(url: string): Promise<T> {
//     const response = await this.axiosInstance.delete<T>(url);
//     return response.data;
//   }
// }

// export default new ApiService();

import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig
} from 'axios';
import { LOGIN_ROUTE } from '../constants/routes';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Separate instance used only for the refresh call - NOT subject to the response interceptor
export const refreshAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

class ApiService {
  private axiosInstance: AxiosInstance;
  private isRefreshing = false;
  private failedQueue: any[] = [];

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: API_URL,
      timeout: 15000,
      withCredentials: true, // ✅ REQUIRED for HttpOnly cookies
      headers: {
        'Content-Type': 'application/json',
      },
    });


    this.setupInterceptors();
  }

  private processQueue(error: any, token: string | null = null) {
    this.failedQueue.forEach(prom => {
      if (error) prom.reject(error);
      else prom.resolve(token);
    });
    this.failedQueue = [];
  }

  // private setupInterceptors(): void {
  //   /** REQUEST */
  //   this.axiosInstance.interceptors.request.use(
  //     (config: InternalAxiosRequestConfig) => {
  //       const token = localStorage.getItem('accessToken');
  //       if (token) {
  //         config.headers.Authorization = `Bearer ${token}`;
  //       }
  //       return config;
  //     }
  //   );

  //   /** RESPONSE */
  //   this.axiosInstance.interceptors.response.use(
  //     (response) => response,
  //     async (error: AxiosError) => {
  //       const originalRequest: any = error.config;

  //       if (error.response?.status === 401 && !originalRequest._retry) {
  //         if (this.isRefreshing) {
  //           return new Promise((resolve, reject) => {
  //             this.failedQueue.push({
  //               resolve: (token: string) => {
  //                 originalRequest.headers.Authorization = `Bearer ${token}`;
  //                 resolve(this.axiosInstance(originalRequest));
  //               },
  //               reject
  //             });
  //           });
  //         }

  //         originalRequest._retry = true;
  //         this.isRefreshing = true;

  //         try {
  //           const response = await this.axiosInstance.post('/api/auth/refresh-token');
  //           const newAccessToken = response.data.accessToken;

  //           localStorage.setItem('accessToken', newAccessToken);

  //           this.processQueue(null, newAccessToken);
  //           originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

  //           return this.axiosInstance(originalRequest);
  //         } catch (err) {
  //           this.processQueue(err, null);
  //           localStorage.clear();
  //           window.location.href = '/login';
  //           return Promise.reject(err);
  //         } finally {
  //           this.isRefreshing = false;
  //         }
  //       }

  //       return Promise.reject(error);
  //     }
  //   );
  // }



  private setupInterceptorss(): void {
    // Response interceptor - handle 401
    this.axiosInstance.interceptors.response.use(
      response => response,
      async (error: AxiosError) => {
        const originalRequest: any = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
          if (this.isRefreshing) {
            return new Promise((resolve, reject) => {
              this.failedQueue.push({
                resolve: () => resolve(this.axiosInstance(originalRequest)),
                reject
              });
            });
          }

          originalRequest._retry = true;
          this.isRefreshing = true;

          try {
            // call refresh endpoint (cookie sent automatically)
            const response = await this.axiosInstance.post('/auth/refresh-token');
            this.processQueue(null);
            return this.axiosInstance(originalRequest);
          } catch (err) {
            this.processQueue(err, null);
            window.location.href = '/login';
            return Promise.reject(err);
          } finally {
            this.isRefreshing = false;
          }
        }

        return Promise.reject(error);
      }
    );
  }
  private setupInterceptors(): void {
    // ✅ NO request interceptor needed - cookies are sent automatically

    // Response interceptor - handle 401 errors
    this.axiosInstance.interceptors.response.use(
      response => response,
      async (error: AxiosError) => {
        const originalRequest: any = error.config;

        // Skip refresh for requests that opted out (e.g. pre-login auth check)
        if (originalRequest?._skipRefresh) {
          return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {

          if (this.isRefreshing) {
            return new Promise((resolve, reject) => {
              this.failedQueue.push({
                resolve: () => {
                  resolve(this.axiosInstance(originalRequest));
                },
                reject
              });
            });
          }

          originalRequest._retry = true;
          this.isRefreshing = true;

          try {
            // ✅ Use a separate axios instance so the refresh call does NOT
            //    re-trigger this interceptor and cause a deadlock / loop
            await refreshAxios.post('/api/auth/refresh-token');

            // ✅ New tokens set as cookies automatically by server
            this.processQueue(null);

            // ✅ Retry original request - cookies sent automatically
            return this.axiosInstance(originalRequest);

          } catch (err) {
            this.processQueue(err, null);
            // ✅ Only redirect if not already on the login page. The check has
            //    to name the same path we navigate to, or the redirect fires
            //    again on every 401 raised from the login screen itself.
            if (window.location.pathname !== LOGIN_ROUTE) {
              window.location.href = LOGIN_ROUTE;
            }
            return Promise.reject(err);
          } finally {
            this.isRefreshing = false;
          }
        }

        return Promise.reject(error);
      }
    );
  }

  /** API METHODS */
  async get<T>(url: string, config: any = {}): Promise<T> {
    const res = await this.axiosInstance.get<T>(url, config);
    console.log('GET', url, 'response:', res);
    return res.data;
  }

  async post<T>(url: string, data?: any, config: any = {}): Promise<T> {
    const res = await this.axiosInstance.post<T>(url, data, config);
    return res.data;
  }

  async put<T>(url: string, data?: any): Promise<T> {
    const res = await this.axiosInstance.put<T>(url, data);
    return res.data;
  }

  async delete<T>(url: string): Promise<T> {
    const res = await this.axiosInstance.delete<T>(url);
    return res.data;
  }
}

export default new ApiService();
